import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getContests, voteContest, uploadMedia } from '../api';

const ContestPage = () => {
  const { auth } = useAuth();
  const [contests, setContests] = useState([]);
  const [receiptFile, setReceiptFile] = useState(null);
  const [selectedContestant, setSelectedContestant] = useState('');

  const loadContests = async () => {
    const token = await auth.currentUser.getIdToken();
    const data = await getContests(token);
    setContests(data);
  };

  useEffect(() => {
    loadContests();
  }, []);

  const handleVote = async (contestId) => {
    if (!selectedContestant || !receiptFile) {
      alert('Pick a contestant and upload a receipt');
      return;
    }
    const token = await auth.currentUser.getIdToken();
    const base64 = await fileToBase64(receiptFile);
    const uploadResult = await uploadMedia({ base64, resourceType: 'image' }, token);
    await voteContest(contestId, { contestantId: selectedContestant, receiptUrl: uploadResult.url, amount: 1000 }, token);
    alert('Vote submitted to queue');
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-secondary mb-8">🏆 Contest Voting</h2>
        
        {contests.length === 0 ? (
          <div className="bg-surface rounded-lg shadow-md p-8 text-center border-l-4 border-accent">
            <p className="text-text-light text-lg">No active contests. Check back soon! ⏳</p>
          </div>
        ) : (
          <div className="space-y-6">
            {contests.map((contest) => (
              <div key={contest.id} className="bg-surface rounded-lg shadow-md overflow-hidden border-l-4 border-accent hover:shadow-lg transition">
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-secondary mb-3">{contest.title}</h3>
                  <p className="text-text-light mb-4">{contest.description}</p>
                  <div className="grid md:grid-cols-3 gap-4 mb-6 p-4 bg-background rounded-lg">
                    <div>
                      <p className="text-text-light text-sm">Status</p>
                      <p className="text-lg font-bold text-primary">{contest.isActive ? '✅ Active' : '❌ Inactive'}</p>
                    </div>
                    <div>
                      <p className="text-text-light text-sm">Total Votes</p>
                      <p className="text-lg font-bold text-accent">{contest.totalVotes || 0}</p>
                    </div>
                    <div>
                      <p className="text-text-light text-sm">Contestants</p>
                      <p className="text-lg font-bold text-secondary">{contest.contestants?.length || 0}</p>
                    </div>
                  </div>
                  
                  <div className="mb-6">
                    <h4 className="font-bold text-text mb-4">👥 Contestants</h4>
                    <div className="space-y-3">
                      {contest.contestants?.map((contestant) => (
                        <label key={contestant.id} className="flex items-center p-4 border-2 border-gray-200 rounded-lg hover:border-primary hover:bg-background transition cursor-pointer">
                          <input
                            type="radio"
                            name="contestant"
                            value={contestant.id}
                            onChange={() => setSelectedContestant(contestant.id)}
                            className="w-5 h-5 text-primary cursor-pointer"
                          />
                          <span className="ml-3 flex-1">
                            <span className="font-semibold text-text">{contestant.name}</span>
                            <span className="text-accent font-bold ml-2">({contestant.voteCount || 0} votes)</span>
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="border-t-2 border-gray-200 pt-6">
                    <h4 className="font-bold text-text mb-4">📸 Upload Receipt</h4>
                    <div className="mb-4">
                      <input 
                        type="file" 
                        accept="image/*" 
                        onChange={(e) => setReceiptFile(e.target.files[0])}
                        className="w-full border-2 border-dashed border-gray-300 rounded-lg p-4 cursor-pointer hover:border-primary transition"
                      />
                    </div>
                    <button 
                      onClick={() => handleVote(contest.id)}
                      disabled={!selectedContestant || !receiptFile}
                      className="w-full bg-primary text-surface font-bold py-3 rounded-lg hover:bg-primary/90 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                      🗳️ Submit Vote
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContestPage;
